import React from "react"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import { adminClient as client } from "src/urql-client"

import { gql, useQuery } from "hooks/urql"

import DegreeInfoModal from "./DegreeInfoModal"

const TutorDegrees: React.FC = () => {
  const [result, refetchDegrees] = useQuery({ query, client })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { requestedDegrees } }) => (
        <>
          {requestedDegrees.length === 0 ? (
            "No degrees submitted"
          ) : (
            <table className="table">
              <thead className="text-primary">
                <tr>
                  <th>Tutor</th>
                  <th>Field of Study</th>
                  <th>College</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {requestedDegrees.map(degree => (
                  <tr key={degree.id}>
                    <td>
                      <a href={degree.tutor.showPath}>
                        {degree.tutor.fullName}
                      </a>
                    </td>
                    <td>{degree.degree}</td>
                    <td>
                      {degree.college} ({degree.country})
                    </td>
                    <td>
                      <DegreeInfoModal
                        degree={degree}
                        refetchDegrees={refetchDegrees}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query RequestedDegreesQuery {
    requestedDegrees {
      id
      college
      year
      country
      degree
      degreeType
      level
      levelOther
      inUsa
      diplomaMill
      tutor: model {
        ... on Tutor {
          id
          fullName
          showPath
        }
      }
      transcript {
        filename
        downloadUrl
      }
    }
  }
`

export default TutorDegrees
